/* eslint-disable no-bitwise, no-restricted-syntax */

/**
 * Convert a string into a number hash
 * https://stackoverflow.com/a/7616484/1868365
 * @param  {String} string
 * @return {Number}
 */
export default function stringToHash(string) {
  let hash = 0;
  for (const char of string) {
    hash = (hash << 5) - hash + char.charCodeAt(0);
    hash |= 0; // Constrain to 32bit integer
  }
  return hash;
}
